module.exports = __webpack_public_path__ + "img/saquif.d917dfca.jpg";